// シンボル = プレイヤーの舞台そのもの。上下 2 本の注視点マーカー(ink)が
// 動かない目を、その間の朱の一点がチャンク(声)を表す。16 グリッドで設計し、
// public/favicon.svg と同じ座標を使う(favicon は枠と背景を足しただけ)。
// viewBox は図形の外接矩形(幅 6)に詰め、隣の文字との間隔を gap だけで決める。
// size は高さ。幅は size × 6/16。16 の倍数にすると画素に揃う。
export function LogoMark({ size = 32, className = "" }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="5 0 6 16"
      width={(size * 6) / 16}
      height={size}
      aria-hidden
      className={`shrink-0 text-ink ${className}`}
      shapeRendering="crispEdges"
    >
      <rect x="7" y="0" width="2" height="4" fill="currentColor" />
      <rect x="7" y="12" width="2" height="4" fill="currentColor" />
      <rect x="5" y="5" width="6" height="6" className="fill-shu" />
    </svg>
  );
}

export function Logo({ sub }: { sub?: string }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <LogoMark size={32} />
      <span className="flex flex-col leading-none">
        <span className="text-[19px] font-black tracking-[-0.02em]">Perusor</span>
        {sub && <span className="mt-1 text-[9px] font-bold tracking-[0.2em] text-ink-3">{sub}</span>}
      </span>
    </span>
  );
}
